import React, { useState } from 'react'
import { CBadge, CCard, CCardBody, CCardHeader, CCol, CFormSwitch, CRow } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import * as icons from '@coreui/icons'
import { useNavigate } from 'react-router-dom'
import { STATUS_BADGE_COLOR, STATUS_LABEL, STEP_ICON } from './stepStatus'

const LaunchEssentialsGrid = ({ steps }) => {
  const navigate = useNavigate()
  const [showOnlyIncomplete, setShowOnlyIncomplete] = useState(false)

  const visibleSteps = showOnlyIncomplete
    ? steps.filter((step) => step.status !== 'completed')
    : steps

  return (
    <CCard className="mb-4" id="launch-essentials">
      <CCardHeader className="d-flex justify-content-between align-items-center">
        <div>
          <div>Launch Essentials</div>
          <small className="text-medium-emphasis">
            These settings are required to launch your game. Click any item to configure.
          </small>
        </div>
        <CFormSwitch
          label="Show only incomplete"
          checked={showOnlyIncomplete}
          onChange={(e) => setShowOnlyIncomplete(e.target.checked)}
        />
      </CCardHeader>
      <CCardBody>
        <CRow>
          {visibleSteps.map((step) => (
            <CCol md={6} key={step.key} className="mb-3">
              <CCard
                className="h-100"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(step.route)}
              >
                <CCardBody className="d-flex align-items-center">
                  <CIcon icon={icons[STEP_ICON[step.key]]} size="xl" className="me-3" />
                  <div className="flex-grow-1">
                    <div className="fw-bold">{step.label}</div>
                    <small className="text-medium-emphasis">{step.description}</small>
                  </div>
                  <CBadge
                    color={STATUS_BADGE_COLOR[step.status]}
                    shape="rounded-pill"
                    className="me-2"
                  >
                    {STATUS_LABEL[step.status]}
                  </CBadge>
                  <CIcon icon={icons.cilChevronRight} />
                </CCardBody>
              </CCard>
            </CCol>
          ))}
        </CRow>
      </CCardBody>
    </CCard>
  )
}

export default LaunchEssentialsGrid
